import * as React from 'react';
import Grid from '@material-ui/core/Grid';
import Typography from '@material-ui/core/Typography';
import Divider from '@material-ui/core/Divider';
import Paper from '@material-ui/core/Paper';
import { Theme, withStyles, WithStyles } from '@material-ui/core/styles';
import { WithTitle } from '../../common/props/layoutProps';

const styles = (theme: Theme) => ({
    title: {
        padding: theme.spacing(2)
    }
});

type BlockProps = WithTitle & WithStyles<"title">;

const StatisticsBlock: React.SFC<BlockProps> = (props) => {

    const { classes, title } = props;

    return (
        <Grid item xs={12} md={6}>
            <Paper>
                <Grid container direction="column">
                    <Grid item xs={12}>
                        <Typography className={classes.title} color="primary" variant="subtitle1">{title}</Typography>
                    </Grid>
                    <Grid item xs={12}>
                        <Divider />
                    </Grid>
                    <Grid item xs={12}>
                        {props.children}
                    </Grid>
                </Grid>
            </Paper>
        </Grid>
    );
}

export default withStyles(styles)(StatisticsBlock);


// WEBPACK FOOTER //
// ./src/statistics/components/StatisticsBlock.tsx